import React from 'react'
import type { IntlShape } from 'react-intl'
import LineMoneyBillSlashIcon from 'LuxKit/Icons/line/LineMoneyBillSlashIcon'
import LineSmileIcon from 'LuxKit/Icons/line/LineSmileIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import { formatRoundedAmountWithDollarType } from 'lib/format/formatCurrencyIntl'
import { getAtomeBpMaxLimit } from 'lib/payment/atomeBpUtils'

export function getStepsHowItWorks(intl: IntlShape) {
  return [
    {
      image: <LineCalendarIcon size="XL" />,
      title: intl.formatMessage({
        id: '9MV7cY9mnwsT2aHz45WB',
        defaultMessage: 'Pay in three instalments',
        description: 'Step 1 title for How it works section on Atome landing page',
      }),
      description: intl.formatMessage({
        id: 'ngEX_iMh3kkKZH-BQJcf',
        defaultMessage: 'Pay your first instalment at the time of purchase and the rest in 2 equal, 30-day instalments.',
        description: 'Step 1 description for How it works section on Atome landing page',
      }),
    },
    {
      image: <LineMoneyBillSlashIcon size="XL" />,
      title: intl.formatMessage({
        id: 'nKfpZsedAANVsLdkvVlv',
        defaultMessage: 'No hidden fees or charges, ever',
        description: 'Step 2 title for How it works section on Atome landing page',
      }),
      description: intl.formatMessage({
        id: 'rHl002aBl0IruqTFlQxR',
        defaultMessage: 'The only fees are for late payments. But don’t worry, Atome will send you regular reminders.',
        description: 'Step 2 description for How it works section on Atome landing page',
      }),
    },
    {
      image: <LineSmileIcon size="XL" />,
      title: intl.formatMessage({
        id: 'K0-aN8Vxhr1bCpEAq0Io',
        defaultMessage: 'No minimum spend',
        description: 'Step 3 title for How it works section on Atome landing page',
      }),
      description: intl.formatMessage({
        id: '-N0Cwj5EJqv0zMv8yyP8',
        defaultMessage: 'Get what you need, when you need it, without any minimum spend.',
        description: 'Step 3 description for How it works section on Atome landing page',
      }),
    },
  ]
}

export function getStepsBuyNow(intl: IntlShape, currency: string, regionCode: string) {
  return [
    {
      title: '1',
      description: intl.formatMessage({
        id: 'GqzKCNA9IICwlyhdZLbz',
        defaultMessage: 'Browse your favourite escapes',
        description: 'Step 1 description for Buy now section on Atome landing page',
      }),
    },
    {
      title: '2',
      description: intl.formatMessage(
        {
          id: 'YbAorvNQ1R3YH-HS_7Nr',
          defaultMessage: 'Select Atome as your payment method for purchases of {maxLimit} and under',
          description: 'Step 2 description for Buy now section on Atome landing page with max purchase limit',
        },
        {
          maxLimit: formatRoundedAmountWithDollarType(getAtomeBpMaxLimit(currency), currency, regionCode),
        },
      ),
    },
    {
      title: '3',
      description: intl.formatMessage({
        id: 'LoOmcXITs2fDT8QkcoOE',
        defaultMessage: 'Instantly create an account or login and pay your first instalment at the time of purchase',
        description: 'Step 3 description for Buy now section on Atome landing page',
      }),
    },
  ]
}

export const getTermsAndConditionsUrlLink = (currency: string) => {
  switch (currency) {
    case 'SGD':
      return 'https://www.atome.sg/terms-of-service'
    case 'MYR':
      return 'https://www.atome.my/en-my/terms-of-service'
    case 'HKD':
      return 'https://www.atome.hk/terms-of-service'
    default:
      return 'https://www.atome.sg/terms-of-service'
  }
}
